/** basic.deviceList — русская локализация (соответствует zh.js) */
export default {
    delDevTip: "Это действие удалит выбранные устройства. Продолжить?",
    beginTime: "Выберите время начала",
    endTime: "Выберите время окончания",
    timeTips: "Убедитесь, что формат времени: ЧЧ:мм:сс",
    bufangSucc: "Время постановки на охрану установлено",
    bufangFail: "Не удалось установить время постановки на охрану",
    beginBuFang: "Поставить на охрану",
    cancelBuFang: "Время охраны для выбранных устройств отменено",
    OperationFailed: "Операция не выполнена",
    search_isInstall: "Установлено",
    Locked_status: "Статус блокировки",
    state_title: "Статистика состояния устройств",
    state_one: "Все состояния",
    state_offline: "Офлайн",
    state_tamperd: "Демонтаж",
    state_highTemperature: "Высокая температура",
    state_low_signal: "Слабый сигнал",
    state_lowBattery: "Низкий заряд",
    state_mainPower: "Неисправность основного питания",
    state_fault: "Неисправность датчика",
    state_alarm: "Тревога",
    state_normal: "Норма",
    state_batteryState: "Состояние батареи",
    state_valveState: "Состояние клапана",
    push_fail: "Ошибка push",
    setBuFangTime: "Установить время охраны",
    cancelBuFangTime: "Отменить время охраны",

    device_detailTitle: "Сведения об устройстве",
    device_detailBasice: "Основная информация",
    device_detailInstall: "Информация об установке",
    device_detailRun: "Рабочие данные устройства",
    device_detailAlarm: "Обработка тревог",
    device_detailFault: "Устранение неисправностей",
    device_detailVideo: "Видеонаблюдение",
    device_detailAlarmRule: "Правила раннего предупреждения",
    device_detailLInkage: "Правила связи",
    device_crontol: "Управление устройством",

    device_bind: "Привязать",
    device_bindTitle: "Привязка устройства",
    deviceBind_Pla: "Выберите существующий объект или пропустите и создайте новый ниже.",
    device_blockDevice: "Заблокировать",
    device_recogniseBlockDevice:
        "Заблокировать тревоги этого устройства? Всплывающие тревоги больше не будут показываться.",
    device_SuccessfullyBlockedTheDevice: "Устройство заблокировано",
    shieldFailedServerError: "Блокировка не выполнена: ошибка сервера",

    device_order: "Команда",
    device_orderTilte: "Отправка команды",
    device_orderTips: "Отправить эту команду?",
    device_orderNoList: "Нет команд для устройства",
    device_noRunOrder: "Нет команд для отправки",
    device_noOrder: "У устройства нет команд",
    devcie_orderSucc: "Команда отправлена",
    device_orderLose: "Ошибка отправки команды",

    device_controlsTitle: "Дополнительные действия",
    device_controlsInitialize: "Инициализация устройства",
    device_controlsTransfer: "Передача устройства",
    device_controlsRelieveBind: "Отвязать",
    device_controlsClearFault: "Сбросить неисправности",
    device_controlsFang: "Поставить на охрану",
    device_controlsCefang: "Снять с охраны",
    device_controlsLock: "Заблокировать",
    device_controlsRelieveLock: "Разблокировать",
    device_controlsInitializeCont: "Удалить привязку к точке, сбросить в непривязанное состояние",
    device_controlsTransferCont: "Передать устройство в другую организацию",
    device_controlsRelieveBindCont: "Отвязать текущую учётную запись от устройства",
    device_controlsClearFaultCont: "Очистить все неисправности устройства",
    device_controlsFangCont: "Постановка на охрану (все устройства)",
    device_controlsCefangCont: "Снятие с охраны (все устройства)",
    device_controlsLockCont: "Блокировка",
    device_controlsRelieveLockCont: "Снятие блокировки",

    device_locked: "Заблокировано",
    device_notLock: "Не заблокировано",

    device_messgae: "Выберите устройство для операции",
    device_controlsInitializeTips:
        "Будут удалены привязки к точкам и сброшено состояние. Продолжить?",
    device_controlsInitializeSucc: "Инициализация выполнена",
    device_controlsInitializeLose: "Ошибка инициализации",

    device_controlsRelieveBindTips:
        "Будет отвязана текущая учётная запись от устройства. Продолжить?",
    device_controlsRelieveBindSucc: "Устройство отвязано",
    device_controlsRelieveBindLose: "Ошибка отвязки",

    device_controlsClearFaultTips: "Будут очищены все неисправности. Продолжить?",
    device_controlsClearFaultSucc: "Неисправности очищены",
    device_controlsClearFaultLose: "Не удалось очистить неисправности",

    device_controlsFangTips:
        "Поддерживаются датчики двери/ИК/дыма. Продолжить?",
    device_succ: "Успешно",
    device_lose: "Ошибка",
    device_cancel: "Отменено",
    device_warn: "Тревога",

    device_isInfraredDefence: "На охране",
    device_InfraredDefence_Status: "Статус охраны",
    device_InfraredDefence_Status_tip: "Изменить статус охраны устройства?",
    device_controlsLockTips:
        "После блокировки недоступна обработка неисправностей, только тревоги и heartbeat. Заблокировать?",
    device_isLockDevice: "Заблокировать",
    device_controlsLockDevice: "Блокировка устройства",
    device_controlsRelieveLockTDevice: "Снять блокировку",
    device_controlsRelieveLockTips:
        "Разблокировать устройство и восстановить работу?",

    device_controlsTransferContSucc: "Устройство передано",
    device_controlsTransferContLose: "Ошибка передачи",

    device_collectTips: "Добавить устройство в избранное?",

    device_noInstall: "Устройство не установлено",
    device_noCheckDeatil: "Нет доступа к деталям",
    device_checkLose: "Ошибка загрузки деталей",
    device_Novideo: "Не удалось получить адрес воспроизведения",

    drawer_title: "Сведения об устройстве",
    drawer_installNews: "Установка",
    drawer_runData: "Рабочие данные",
    drawer_alarmHandle: "Тревоги",
    drawer_faultHandle: "Неисправности",
    drawer_video: "Видео",
    drawer_alarmRule: "Правила предупреждения",
    drawer_linkageRule: "Связанные правила",
    drawer_pushCondition: "Push",
    drawer_BindUser: "Привязанные пользователи",
    drawer_eventImage: "Изображения событий",
    drawer_attendanceRecord: "Записи посещений",
    attendanceRecord_userName: "Имя пользователя",
    attendanceRecord_createTime: "Время посещения",
    attendanceRecord_image: "Фото посещения",
    attendanceRecord_add: "Добавить",
    attendanceRecord_addTitle: "Добавить запись посещения",
    attendanceRecord_selectImage: "Выбрать фото посещения",
    attendanceRecord_addSucc: "Успешно добавлено",
    attendanceRecord_addLose: "Не удалось добавить",
    attendanceRecord_imageRequired: "Пожалуйста, выберите фото посещения",
    attendanceRecord_createTimeRequired: "Пожалуйста, выберите время посещения",
    attendanceRecord_defaultUserName: "打卡 устройства",

    dialog_title: "Передача устройства",
    enpty_title: "Выберите организацию!!!",

    basice_Title: "Информация об устройстве",
    basice_TwoCode: "QR-код",
    basice_installTime: "Время установки",
    basice_deviceType: "Тип устройства",
    basice_model: "Модель",
    basice_code: "Код модели",
    basice_edit: "Изменить",
    basice_ccid: "ccid",
    basice_telecomID: "ID оператора",
    basice_moveID: "ID мобильной сети",
    basice_imei: "imei",
    basice_imsi: "imsi",
    basice_ToggleChart: "Переключить вид",
    basice_toggleCar: "Карточка",
    basice_deviceStats: "Свойства устройства",
    basice_child: "Подустройство",
    basice_signalStrength: "Уровень сигнала",
    basice_voltage: "Напряжение",
    basice_temperatureNum: "Температура",
    basice_concentrationNum: "Концентрация",
    basice_deviceIMg: "Фото устройства",
    basice_upImg: "Загрузить изображение",
    basice_deleteImgTips: "Удалить изображение устройства?",
    basice_chartTitle: "Тренд параметров",
    basice_temperature: "Температура",
    basice_concentration: "Концентрация",
    basice_chartDeviceNoData: "Нет данных для графика",
    basice_copySucc: "Скопировано",
    basice_copyLose: "Ошибка копирования",
    basice_editSucc: "Сохранено",
    basice_editLose: "Ошибка сохранения",
    basice_humidness: "Влажность",
    basice_HumidityValue: "Значение влажности",
    basice_brightScreen: "Экран вкл.",
    basice_noScreen: "Экран выкл.",
    basice_TemperatureUnit: "Единица температуры",
    basice_DegreeCelsius: "°C",
    basice_Fahrenheit: "°F",
    basice_ScreenState: "Состояние экрана",

    basice_alarm: "Тревога",
    basice_cameraArgu: "Параметры камеры",
    basice_addr: "Адрес",
    basice_state: "Состояние",
    basice_line: "Онлайн",
    basice_transmit: "Режим потока",
    basice_NewHeartbeat: "Последний heartbeat",
    basice_NewSignIn: "Последняя регистрация",
    basice_passage: "Каналы",
    basice_bing: "Привязка",
    basice_editMqtt: "Изменить MQTT",
    basice_editHttp: "Изменить HTTP",
    basice_smoke: "Дымовой датчик 433",
    basice_relieveBind: "Отвязать",
    basice_relieve: "Отвязка",
    basice_setFang: "Зона охраны",
    basice_fang: "Зона",
    basice_confirmEdit: "Подтвердить изменение?",
    basice_ipTips: "IP или домен",
    basice_userNameTIps: "Имя пользователя",
    basice_password: "Пароль",
    basice_bindNameTips: "Имя привязки",
    basice_fangqu: "Название зоны",
    basice_messageCarmes: "Ошибка данных камеры",
    basice_messageDeviceNodata: "Нет данных для графика",
    basice_messageAddr: "Адрес обязателен",
    basice_messageIssueSucc: "Отправлено",
    basice_messageIssueLose: "Ошибка отправки",
    basice_messageNOfang: "Укажите название зоны",
    basice_messageIssueSetSucc: "Зона настроена",
    basice_messageIssueSetLose: "Ошибка настройки зоны",
    basice_messageIssueBind: "Ошибка команды привязки",
    basice_messageCarmesNoSmoke: "К дымовому датчику не подключено",
    basice_messageInquireLose: "Ошибка запроса",
    basice_messageInquire433Lose: "Нет дымового датчика",
    basice_messageIssueORderLose: "Ошибка команды",
    basice_messageNoBindLose: "Ошибка отвязки",

    basice_deviceVoltage: "Напряжение устройства",
    basice_temperatureNew: "Температура на объекте",
    basice_formHUmidness: "Относительная влажность",
    basice_MoverNum: "Число перемещений",
    basice_signalQuality: "Качество сигнала",
    basice_deviceIMSi: "IMSI устройства",
    basice_getDeviceDetilTips: "Ошибка загрузки устройства",

    device_data: "Данные устройства",
    set_harvest_and_cardiac_cycle: "Период опроса и heartbeat",
    eqManage: "Газовые детекторы подземных пространств",
    host_state: "Состояние хоста: ",
    signal_strength: "Сила сигнала: ",
    Low_Battery_Alarm: "Низкий заряд: ",
    Flood_Alarm: "Протечка: ",
    Alarm_for_manhole_cover_movement: "Люк: ",
    signal_strength_rsrp: "RSRP: ",
    signal_to_noise_ratio: "SNR: ",
    Physical_Cell_Marking: "PCI: ",
    BTS_Cell_Marking: "ID соты: ",
    Coverage_enhancement_level: "Уровень покрытия: ",
    XYZ_axis_angle: "Угол XYZ: ",
    X_axis_angle: "Ось X: ",
    Y_axis_angle: "Ось Y: ",
    Z_axis_angle: "Ось Z: ",
    Battery_Voltage: "Напряжение АКБ: ",
    temp: "Темп.: ",
    humidity_level: "Влажность: ",
    collection_period: "Период опроса: ",
    cardiac_cycle: "Heartbeat: ",
    software_version: "Версия ПО: ",
    hardware_version: "Версия железа: ",
    collection_period_input: "Введите период опроса",
    CycleUnit_input: "Введите период heartbeat",
    longitude: "Долгота",
    latitude: "Широта",
    Internal_equipment_pressure: "Давление в устройстве",
    environment_stress: "Давление среды",
    sensitivity: "Чувствительность вибродатчика",
    panel_voltage: "Напряжение солнечной панели",
    shake_alarm: "Вибрация (камера)",
    eqAlarm: "Низкий заряд (камера)",
    cell_video: "Напряжение АКБ (камера)",
    heartBeat_video: "Heartbeat (камера)",
    soft_video: "Версия ПО (камера)",
    videoText: "Камера",

    install_title: "Объект и точка",
    install_checkSiteImg: "Фото объекта",
    install_owner: "Владелец",
    install_ownerPhone: "Телефон владельца",
    install_pointName: "Точка",
    install_pointCont: "Фото точки",
    install_pointAddr: "Адрес точки",
    install_siteImg: "Фото объекта",
    install_mapAddr: "На карте",
    install_copyLatlng: "Копировать координаты",
    install_getSiteNewsLose: "Ошибка загрузки объекта",
    install_getPointNewsLose: "Ошибка загрузки точки",

    operation_alarmTitle: "Тревоги",
    operation_voltage: "Напряжение (мВ)",
    operation_dataSource: "Источник",
    operation_otherData: "Прочее",
    operation_objectExist: "Обнаружен человек",
    operation_objectNotExist: "Человек не обнаружен",
    operation_objectExistTimes: "Обнаружен человек, {count} раз",
    operation_objectNotExistTimes: "Человек не обнаружен, {count} раз",
    operation_firmCoding: "Производитель",
    operation_pushModel: "Модель push",
    operation_pushType: "Тип push",
    operation_pagination: "Страница",
    operation_faultTitle: "Неисправности",
    operation_hearbeat: "Heartbeat",
    operation_releaseRecord: "Журнал команд",
    operation_previous: "Назад",
    operation_NextPage: "Вперёд",
    operation_resultCoding: "Код результата",
    operation_resultDesc: "Описание",

    alarm_handle: "Обработать",
    alarm_succ: "Обработано",
    alarm_dialogTitle: "Обработка тревоги",
    alarm_handlePla: "Причина тревоги",
    alarm_systematicPro: "Система",
    alarm_faultHandle: "Неисправность",
    alarm_isFinishMonad: "Закрыть заявку",
    alarm_yes: "Да",
    alarm_no: "Нет",
    alarm_feedback: "Комментарий",
    alarm_feedbackPla: "Введите комментарий",
    alarm_impor: "Импорт файла",
    alarm_draweTitle: "Неисправность",
    alarm_faultType: "Тип",
    alarm_handleRecords: "Журнал",
    alarm_handleImg: "Фото",
    alarm_ImgCheck: "Просмотр",
    alarm_MessageChcekLose: "Ошибка просмотра",

    bind_entity: "Организация",
    bind_installSite: "Объект установки",
    bind_siteName: "Название объекта",
    bind_siteNameLian: "Связанный объект",
    bind_installPoint: "Точка установки",
    bind_installPointPla: "Введите точку",
    bind_isntallAddr: "Адрес установки",
    bind_installAddrPla: "Введите адрес",
    bind_subBind: "Привязать",
    bind_selectRegion: "Регион",
    bind_siteNameLianPla: "Связанный объект",
    bind_addSite: "Новый объект",
    bind_siteNamePla: "Название объекта",
    bind_siteAddr: "Адрес объекта",
    bind_owner: "Владелец",
    bind_ownerPhone: "Телефон",
    bind_floorNum: "Этажи",
    bind_dialogTitle: "Положение на карте",
    bind_ruleSite: "Выберите объект",
    bind_ruleSiteLength: "От 5 до 50 символов",
    bind_pointName: "Название точки",
    bind_pointLength: "От 1 до 20 символов",
    bind_pointAddr: "Адрес точки",
    bind_pointaddrLength: "От 1 до 100 символов",
    bind_ruleMap: "Укажите на карте",
    bind_messageSucc: "Привязано",
    bind_messageLose: "Ошибка привязки",
    bind_foundSucc: "Создано",
    bind_foundLose: "Ошибка создания",

    alarmRule_OpenState: "Включено",
    alarmRule_isOpen: "Вкл/Выкл",
    alarmRule_event: "Тип события",
    alarmRule_productRank: "Уровень продукта",
    alarmRule_entityRank: "Уровень организации",
    alarmRule_siteRank: "Уровень объекта",
    alarmRule_deviceRank: "Уровень устройства",
    alarmRule_openState: "Изменить состояние правила?",
    alarmRule_drawerTitle: "Пользователи",
    alarmRule_sysUser: "Системные",
    alarmRule_TemUser: "Временные",

    linkRule_linkDeviceCode: "Код связанного устройства",
    linkRule_linkDevice: "Связанное устройство",
    linkRule_triggerDevice: "Инициатор",
    linkRule_triggerEvent: "Событие",
    linkRule_linkeOrder: "Команда связи",
    linkRule_allState: "Все статусы",

    push_aliPhoneRecords: "Звонки (облако)",
    push_linePhoneRecords: "Выделенная линия",
    push_aliSmSRecords: "SMS",
    push_appPush: "Push приложения",
    push_gzhPush: "Официальный аккаунт",

    bindUser_Title: "Привязанные",
    bindUser_userName: "Пользователь",
    bindUser_isFirstBind: "Первый",
    bindUser_firstBind: "Первичная привязка",
    bindUser_ISControls: "Права операций",
    bindUser_canControls: "Да",
    bindUser_noCOntrols: "Нет",
    bindUser_Tips: "Изменить права?",
    bindUser_editRole: "Права",

    basice_DetectorData: "Данные детектора",
    basice_DetectorNumber: "№ детектора",
    basice_SensorType: "Тип датчика",
    basice_report: "Период отчёта",
    basice_4gGas: "Промышленный газ 4G",
    basice_wireLess: "Беспроводной модуль",
    edition: "Версия",

    device_allNnum: "Всего устройств",
    OwnDevice: "С устройствами",
    NoDevice: "Без устройств",
    siteImg: "Фото объекта",
    pointIMg: "Фото точки",
    NoWonerInfo: "Нет владельца",
    selectAll: "Выбрать всё",
    NoSelectAll: "Снять выбор",
    setBufangTime: "Время охраны для выбранных",
    cancelBufangTime: "Снять охрану с выбранных",
    delDev: "Удалить",
    delSucSel: "Удалить выбранные",
    delDevSuc: "Устройства удалены",
    unitFilter: "Фильтр организации",
    fieldDisplay: "Поля",
    broadcast_send: "Отправить трансляцию",
    broadcast_send_tip: "Пакетно отправить трансляцию выбранным устройствам",
    clickSendOrder: "Нажмите для отправки команды",
    noAvailableOrders: "Нет доступных команд",
    fieldVisibility: "Отображение полей списка",
    moreSearchConditions: "Дополнительные условия поиска",
    searchResetDone: "Условия поиска сброшены",
    searchApplied: "Условия поиска применены",
    selectedEntity: "Выбрана организация",
    unitFilterCleared: "Фильтр организации очищен",
    selectDeviceFirst: "Сначала выберите устройство",
    broadcastNoSupportedType: "Среди выбранных устройств нет типов с поддержкой трансляции (камеры)",
    broadcastFilteredPrefix: "Отфильтровано",
    broadcastFilteredMiddle: "устройств без поддержки трансляции, трансляция будет отправлена на",
    broadcastFilteredSuffix: "устройств",
    broadcast_content: "Содержимое трансляции",
    broadcast_content_placeholder: "Введите содержимое трансляции",
    broadcast_play_mode: "Режим воспроизведения",
    broadcast_play_now: "Воспроизвести сразу",
    broadcast_play_now_tip: "(Немедленно отправить трансляцию на устройство)",
    broadcast_play_once: "Воспроизвести в указанное время",
    broadcast_play_once_tip: "(Воспроизвести в указанную дату и время)",
    broadcast_play_daily: "Ежедневное воспроизведение",
    broadcast_play_daily_tip: "(Воспроизводить каждый день в указанное время)",
    broadcast_repeat: "Количество повторов",
    broadcast_repeat_daily_tip: "(Количество воспроизведений в день, 1-10)",
    broadcast_repeat_tip: "(1-10)",
    broadcast_play_time: "Время воспроизведения",
    broadcast_select_datetime: "Выберите дату и время",
    broadcast_daily_at_time: "(Ежедневно в это время)",
    broadcast_select_time: "Выберите время",
    broadcast_select_time_warning: "Выберите время воспроизведения",
    broadcastNoSupportedDevice: "Нет устройств с поддержкой трансляции",
    broadcastSuccessPrefix: "Трансляция успешно отправлена на",
    broadcastSuccessSuffix: "устройств",
    broadcastWillPlayAt: "воспроизведение в",
    broadcastDailyAt: "ежедневное воспроизведение в",
    broadcastPlayTimes: "количество повторов",
    broadcastTimesUnit: "раз",
    broadcastFailed: "Не удалось отправить трансляцию",
    record_result_placeholder: "Выберите результат инспекции",
    record_type_placeholder: "Выберите тип",
    record_site_name: "Название объекта",
    record_type: "Тип",
    record_type_daily: "Плановая инспекция",
    record_type_task: "Задачная инспекция",
    record_result_danger: "Есть риск",
    record_result_fault: "Есть неисправность",
    record_inspector_name: "Имя инспектора",
    record_inspector_phone: "Телефон инспектора",
    record_detail_title: "Детали записи инспекции",
    record_detail_info: "Подробная информация",
    record_inspector_name_input: "Введите имя инспектора",
    record_inspector_phone_input: "Введите телефон инспектора",
    record_remark: "Описание",
    record_remark_input: "Введите описание",
    record_location_info: "Информация о местоположении",
    record_edit_location: "Изменить местоположение",
    record_no_latlng: "Нет данных о широте и долготе",
    record_add_location: "Добавить местоположение",
    record_image_list: "Список изображений",
    record_upload_image: "Загрузить изображение",
    record_image_load_failed: "Не удалось загрузить изображение",
    record_no_image: "Нет изображений",
    record_query_detail_failed: "Не удалось получить детали",
    record_upload_only_image: "Можно загружать только изображения!",
    record_upload_max_10m: "Размер изображения не должен превышать 10 МБ!",
    record_select_first: "Сначала выберите запись инспекции",
    record_delete_image_confirm: "Удалить это изображение?",
    record_delete_confirm: "Удалить эту запись инспекции?",
    danger_level_placeholder: "Выберите уровень риска",
    danger_status_placeholder: "Выберите статус обработки",
    danger_level: "Уровень риска",
    danger_level_1: "Уровень 1",
    danger_level_2: "Уровень 2",
    danger_level_3: "Уровень 3",
    danger_status_label: "Статус обработки",
    danger_status_done: "Обработано",
    danger_status_todo: "Не обработано",
    danger_status_unable: "Невозможно обработать",
    danger_handler_name: "Имя обработчика",
    danger_handler_phone: "Телефон обработчика",
    danger_detail_title: "Детали записи о риске",
    danger_handler_name_input: "Введите имя обработчика",
    danger_handler_phone_input: "Введите телефон обработчика",
    danger_remark: "Описание обработки",
    danger_remark_input: "Введите описание обработки",
    danger_select_first: "Сначала выберите запись о риске",
    danger_delete_confirm: "Удалить эту запись о риске?",
    monitor_deviceListTitle: "Список устройств",
    monitor_device_unit: " устройств",
    monitor_noVideoCannotSet: "Нет видеопотока, настройка недоступна",
    monitor_exceedPointLimit: "Превышено допустимое количество точек координат",
    monitor_noRegionCannotSave: "Периметр не нарисован, сохранить нельзя",
    monitor_noLineCannotSave: "Запретная линия не нарисована, сохранить нельзя",
    monitor_region: "Периметр",
    monitor_forbiddenLine: "Запретная линия",
    monitor_saveSuccess: " успешно сохранено",
    monitor_saveFail: " не удалось сохранить",
    monitor_getDeviceListFailed: "Не удалось получить список устройств",
    monitor_getDeviceListError: "Ошибка при получении списка устройств",
    monitor_noOnlineDevice: "Сейчас нет онлайн-устройств",
    monitor_autoPlayPrefix: "Автоматически запущено",
    monitor_autoPlaySuffix: "онлайн-устройств",
    monitor_deviceListRefreshed: "Список устройств обновлён",
    monitor_searchDone: "Поиск завершён",
    monitor_searchCleared: "Условия поиска очищены",
    monitor_unknownLocation: "Неизвестное местоположение",
    monitor_noIdleWindow: "Нет свободных окон, сначала закройте другие потоки",
    monitor_selectWindowFirst: "Сначала выберите окно видео",
    monitor_closeAllSuccess: "Все видеопотоки закрыты",
    monitor_showAddressSuccess: "Адрес устройства отображён",
    monitor_hideAddressSuccess: "Адрес устройства скрыт",
    point_searchName: "Поиск по названию точки",
    monitor_ptz_up: "Вверх",
    monitor_ptz_left: "Влево",
    monitor_ptz_right: "Вправо",
    monitor_ptz_down: "Вниз",
    monitor_speed_settings: "Настройки скорости",
    monitor_zoom_speed: "Скорость зума",
    monitor_focus_in: "Фокус+",
    monitor_focus_out: "Фокус-",
    monitor_led_timed: "Управление по времени",
    monitor_led_on: "Всегда включено",
    monitor_led_off: "Всегда выключено",
    monitor_control_panel: "Панель управления",
    monitor_device_settings: "Настройки устройства",
    monitor_time_range: "Диапазон времени",
    monitor_video_save_ok: "Настройки видео сохранены",
    monitor_video_save_fail: "Не удалось сохранить настройки видео",
    monitor_audio_save_ok: "Настройки аудио сохранены",
    monitor_audio_save_fail: "Не удалось сохранить настройки аудио",
    monitor_isp_save_ok: "Настройки ISP сохранены",
    monitor_isp_save_fail: "Не удалось сохранить настройки ISP",
    monitor_led_save_ok: "Настройки LED сохранены",
    monitor_led_save_fail: "Не удалось сохранить настройки LED",
    monitor_ai_save_ok: "Параметры AI сохранены",
    monitor_ai_save_fail: "Не удалось сохранить параметры AI",
    monitor_reboot_confirm: "Вы уверены, что хотите перезагрузить устройство?",
    monitor_ai_params_title: "Настройки параметров AI",
    monitor_close_line: "Закрыть запретную линию",
    monitor_kitchen_ai: "Параметры распознавания кухни",
    monitor_fire_save_ok: "Настройки распознавания пламени сохранены",
    monitor_fire_save_fail: "Не удалось сохранить настройки распознавания пламени",
    monitor_ebike_save_ok: "Настройки распознавания электровелосипеда сохранены",
    monitor_ebike_save_fail: "Не удалось сохранить настройки распознавания электровелосипеда",
    monitor_kitchen_save_ok: "Настройки распознавания кухни сохранены",
    monitor_kitchen_save_fail: "Не удалось сохранить настройки распознавания кухни",
    monitor_ai_all_save_ok: "Все параметры AI успешно сохранены",
    monitor_all_save_fail: "Не удалось сохранить все настройки",
    monitor_recover_ok: "Настройки восстановлены",
    monitor_recover_fail: "Не удалось восстановить настройки",
    monitor_recover_all_ok: "Все настройки восстановлены",
    monitor_recover_all_fail: "Не удалось восстановить все настройки",
    monitor_region_closed: "Периметр закрыт",
    monitor_region_close_fail: "Не удалось закрыть периметр",
    monitor_line_closed: "Запретная линия закрыта",
    monitor_line_close_fail: "Не удалось закрыть запретную линию",
    p2p_local_id: "Локальный ID",
    p2p_peer_id: "Вызываемый терминал",
    p2p_terminal_placeholder: "Введите/выберите ID терминала",
    p2p_media_settings: "Настройки медиа",
    p2p_control_menu: "Меню управления",
    p2p_clear_canvas: "Очистить холст",
    p2p_camera_control_menu: "Меню управления камерой",
    p2p_device_control: "Управление устройством",
    p2p_common_parameters: "Общие параметры",
    p2p_ai_parameters: "Параметры AI",
    p2p_remote_media: "Удаленное медиа",
    p2p_audio: "Аудио",
    p2p_video: "Видео",
    p2p_all: "Все",
    p2p_call: "Вызов",
    p2p_hangup: "Завершить",
    p2p_calling: "Вызов...",
    p2p_no_video_cannot_set: "Нет видеопотока, настройка невозможна",
    p2p_no_region_cannot_save: "Периметр не нарисован, сохранить нельзя",
    p2p_no_line_cannot_save: "Запретная линия не нарисована, сохранить нельзя",
    p2p_points_exceeded: "Превышено допустимое количество точек",
    p2p_record: "Записи",
    p2p_select_placeholder: "Пожалуйста, выберите",
    p2p_confirm_close_relay: "Вы уверены, что хотите отключить выход реле?",
    p2p_confirm_open_relay: "Вы уверены, что хотите включить выход реле?",
    p2p_confirm_close_alarm_relay: "Вы уверены, что хотите отключить аварийную релейную связь?",
    p2p_confirm_open_alarm_relay: "Вы уверены, что хотите включить аварийную релейную связь?",
    p2p_confirm_close_region: "Вы уверены, что хотите отключить периметр распознавания пламени?",
    p2p_confirm_open_region: "Вы уверены, что хотите включить периметр распознавания пламени?",
    p2p_confirm_close_line: "Вы уверены, что хотите отключить запретную линию для электровелосипеда?",
    p2p_confirm_open_line: "Вы уверены, что хотите включить запретную линию для электровелосипеда?",
    p2p_select_device_first: "Сначала выберите устройство для запроса записей",
    p2p_select_time_range: "Выберите диапазон времени",
    p2p_font: "Шрифт",
    p2p_select_font: "Выберите шрифт",
    p2p_font_size: "Размер шрифта",
    p2p_font_color: "Цвет шрифта",
    p2p_font_song: "Song",
    p2p_font_hei: "Hei",
    p2p_font_fangsong: "FangSong",
    p2p_font_kaiti: "KaiTi",
    p2p_font_yahei: "Microsoft YaHei",
    p2p_placeholder_content: "Введите содержимое",
    p2p_osd_limit_exceeded: "Содержимое OSD превышает лимит, уменьшите текст или размер шрифта",
    p2p_osd_text_settings: "Настройки текста OSD",
    p2p_text_content: "Текст",
    p2p_to: "до",
    track_clear: "Очистить трек",
    track_all: "Все треки",
    track_gps: "GPS трек",
    track_lbs: "LBS трек",
    fence_edit: "Редактировать ограждение",
    fence_end_edit: "Завершить редактирование",
    fence_open: "Включить ограждение",
    fence_close: "Отключить ограждение",
    fence_setting: "Настройка ограждения",
    fence_set: "Установлено",
    fence_unset: "Не установлено",
    fence_status: "Статус ограждения",
    positioning_mode: "Режим позиционирования",
    gas_trackPath: "Трек перемещения",
    gas_electronicFence: "Геозона",
    gas_positioningType: "Тип позиционирования",
    gas_attrData: "Данные атрибутов",
    gas_historyDataTab: "История",
    mqtt_led_control_setting: "Настройка LED",
    other_operations_colon: "Другие действия:",
    fence_need_gps: "Сначала включите GPS-позиционирование для настройки геозоны",
    fence_open_first: "Сначала включите геозону",
    fence_end_edit_first: "Сначала завершите редактирование",
    fence_open_success: "Успешно включено",
    fence_open_fail: "Не удалось включить",
    fence_close_success: "Успешно отключено",
    fence_close_fail: "Не удалось отключить",
    camera_relay_status_switch: "Переключатель статуса релейной аварийной связи",
    camera_led_mode: "Режим управления LED",
    camera_led_always_on: "Всегда включено",
    camera_led_always_off: "Всегда выключено",
    camera_start_time_placeholder: "Время начала (например 18:00)",
    camera_end_time_placeholder: "Время окончания (например 06:00)",
    camera_time_format_error: "Введите время в формате mm:ss, например 06:00",
    gateway_jkd_tcp: "Шлюз 433 - протокол JiKaida TCP",
    oneclick_basic_info: "Базовая информация кнопки SOS",
    oneclick_playbell_confirm: "Выполнить настройку воспроизведения звонка?",
    oneclick_playbell: "Воспроизвести звонок",
    oneclick_init_confirm: "Выполнить инициализацию этого устройства?",
    oneclick_init_device: "Инициализировать устройство",
    oneclick_alarm: "Тревога",
    oneclick_normal: "Норма",
    oneclick_no_status: "Нет статуса",
    oneclick_volume: "Громкость",
    oneclick_phone_settings: "Настройка номеров SOS",
    oneclick_phone_placeholder: "Введите номер",
    oneclick_emergency_number: "Экстренный номер",
    oneclick_alarm_number: "Тревожный номер",
    oneclick_sos_numbers: "Номера SOS",
    oneclick_number_order: "Порядковый номер",
    oneclick_number_type: "Тип номера",
    oneclick_call_records: "Журнал вызовов",
    oneclick_call_duration: "Длительность вызова",
    oneclick_call_direction: "Направление вызова",
    oneclick_call_status: "Статус вызова",
    oneclick_outgoing: "Исходящий",
    oneclick_incoming: "Входящий",
    oneclick_not_connected: "Не соединено",
    oneclick_connected: "Соединено",
    oneclick_location_records: "Записи координат",
    oneclick_lnglat: "Долгота/Широта",
    oneclick_heartbeat_time: "Время heartbeat",
    oneclick_signal_strength: "Уровень сигнала",
    oneclick_battery: "Батарея",
    oneclick_unread_voice: "Непрочитанные голосовые SMS",
    oneclick_terminal_type: "Тип терминала",
    oneclick_sos_status: "Статус SOS",
    oneclick_mute_status: "Статус беззвучного режима",
    oneclick_positioning_priority: "Приоритет позиционирования",
    oneclick_positioning_switch: "Переключатель позиционирования",
    oneclick_positioning_off: "Позиционирование выключено",
    oneclick_fault_type: "Тип неисправности",
    oneclick_fault_sensor: "Неисправность датчика",
    oneclick_fault_battery: "Неисправность батареи",
    oneclick_fault_gyro: "Неисправность гироскопа",
    oneclick_fault_infrared: "Неисправность ИК-детекции",
    oneclick_fault_gps_module: "Неисправность модуля GPS",
    oneclick_whitelist_mode: "Режим белого списка",
    oneclick_voice_mode: "Голосовой режим",
    oneclick_voice_wakeup: "Голосовое пробуждение",
    oneclick_voice_confirm: "Голосовое подтверждение",
    oneclick_voice_off: "Голос отключен",
    event_water_alarm: "Тревога затопления",
    event_manhole_alarm: "Тревога смещения люка",
    event_voice_alarm: "Тревога распознавания голоса",
    event_smoke_sensor_alarm: "Тревога дымового датчика",
    event_co_alarm: "Тревога угарного газа",
    event_gas_alarm: "Тревога горючего газа",
    event_device_removed: "Устройство демонтировано",
    event_high_temp_alarm: "Тревога высокой температуры",
    event_humidity_alarm: "Тревога влажности",
    event_infrared_alarm: "Инфракрасная тревога",
    event_reset: "Сброс",
    event_manual_wakeup: "Ручное пробуждение",
    event_gps_positioning: "GPS позиционирование",
    event_density_alarm: "Тревога концентрации",
    event_displacement_alarm: "Тревога смещения",
    drag_to_modify_point: "Перетащите маркер, чтобы изменить точку",
}
